var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-card',[_c('p',{staticClass:"text-h6 text-center"},[_vm._v("Rubber Mishap")]),_c('p',[_vm._v("This part of MyPEEPS is all about testing your BottomLine - with partners, settings, and now with alcohol and other drugs.")])])}
var staticRenderFns = []

export { render, staticRenderFns }